<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" inline>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="设计编号：">
                <el-input size="small" style="width: 400px" v-model="queryParams.order" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="转换设计编号：">
                <el-input size="small" style="width: 400px" v-model="queryParams.number" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建时间：">
                <el-date-picker
                  size="small"
                  v-model="queryParams.time"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="order-form-sear-btn">
            <el-button size="small">重置</el-button>
            <el-button size="small" type="primary">搜索</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
      <el-table v-loading="loading" :data="tableData" border>
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="品台产品" width="400">
          <template slot-scope="scope">
            <el-row :gutter="24">
              <el-col :span="4">
                <div>
                  <img width="60" height="80" :src="scope.row.product.imgUrl" alt="" />
                </div>
              </el-col>
              <el-col :span="20">
                <div style="height: 40px">
                  产品名称：<el-button type="text">Mouse Pad Computer,Laptop,Gaming</el-button>
                </div>
                <div>
                  设计编号： 261038246
                </div>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column label="定制产品" width="400">
          <template slot-scope="scope">
            <el-row :gutter="24">
              <el-col :span="4">
                <div>
                  <img width="60" height="80" :src="scope.row.product.imgUrl" alt="" />
                </div>
              </el-col>
              <el-col :span="20">
                <div style="height: 40px">
                  产品名称：<el-button type="text">Mouse Pad Computer,Laptop,Gaming</el-button>
                </div>
                <div>
                  设计编号：234234234
                </div>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operator"></el-table-column>
        <el-table-column label="创建时间" prop="ctime"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="handleDeleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb';

export default {
  components: { Breadcrumb },
  data() {
    return {
      queryParams: {
        pageSize: 30,
        pageNum: 1,
      },
      importFileVisible: false,
      fileForm: {},
      total: 0,
      loading: false,
      tableData: [
        {
          product: {
            imgUrl:
              'https://nimg5.hicustom.com/static/productDet/XE45E3-1-29-1-1000-41eaca048ef564007f462d641f1f191b.jpg',
          },
          relatedProduct: {
            imgUrl:
              'https://nimg5.hicustom.com/static/productDet/XE45E3-1-29-1-1000-41eaca048ef564007f462d641f1f191b.jpg',
          },
          ctime: '2021-04-10 23:22:21',
          operator: 'xxx',
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /* 获取列表数据 */
    loadData() {
      this.total = 1;
    },
    /* 下载数据 */
    handleDownload(row) {},
    /* 删除 */
    handleDeleteItem(row) {
      this.$XModal
        .confirm('是否确认删除？联', '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
        .then(() => {})
        .then(() => {
          this.msgSuccess('删除成功');
          this.loadData();
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
